import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    extendedAllowedAttachmentExtensions: [
        'ppt',
        'pptx',
        'csv',
        'xml',
        'gpc',
        'sta',
        'kpc',
        'cfd',
        'cfa',
        'heic',
    ],
};
